// src/service/TarjetaVecino.js
import instance from "../apis/app";

const TarjetaVecino = {
  /**
   * Valida si un RUT tiene tarjeta vecino vigente
   * @param {string} rut - RUT en formato "12345678-9"
   * @returns {Promise}
   */
  Validar: async (rut) => {
    try {
      const response = await instance.get('/tarjeta-vecino/validar', {
        params: { rut }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Valida múltiples RUTs
   * @param {string[]} ruts
   * @returns {Promise}
   */
  ValidarMultiples: async (ruts) => {
    try {
      const response = await instance.post('/tarjeta-vecino/validar-multiples', {
        ruts
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default TarjetaVecino;
